import * as React from 'react';
import { PrescriberDetailCRM } from './views/PrescriberDetailCRM';
import { CreatePrescripteurCRM } from './views/CreatePrescripteurCRM';
import CRMRoot from './views/CRMRoot';
import { crmBasePath } from './constants/paths';

export const CRMRouter = {
    path: crmBasePath,
    element: <CRMRoot />,
    handle: { title: 'CRM' },
    children: [
        {
            path: 'prescripteur/creer',
            element: <CreatePrescripteurCRM />,
            handle: { title: 'CRM - Créer un prescripteur' },
        },
        {
            path: 'prescripteur/:id',
            element: <PrescriberDetailCRM />,
            handle: { title: 'CRM - Fiche prescripteur' },
        },
    ],
};
